var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-name" }, [
          _c("h2", { attrs: { id: "benefitHeader" } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.pageTitle) +
                "\n                "
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Back")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content CustomPadTop0" }, [
          _c("div", { staticClass: "card-body" }, [
            _c(
              "form",
              { attrs: { id: "changeProfile" } },
              [
                _c("div", { staticClass: "col-md-6 CustomPad00" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          name: "location",
                          placeholder: "Type location here",
                          label: "location_name",
                          id: "selectedLocation",
                          options: _vm.locationOptions
                        },
                        on: {
                          input: function($event) {
                            return _vm.onchangeLocation()
                          }
                        },
                        model: {
                          value: _vm.selectedLocation,
                          callback: function($$v) {
                            _vm.selectedLocation = $$v
                          },
                          expression: "selectedLocation"
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.locationError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-6 CustomPad00" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          name: "station",
                          placeholder: "Type station here",
                          label: "station_name",
                          id: "selectedStation",
                          options: _vm.stationOptions
                        },
                        on: {
                          input: function($event) {
                            return _vm.onChnageStation()
                          }
                        },
                        model: {
                          value: _vm.selectedStation,
                          callback: function($$v) {
                            _vm.selectedStation = $$v
                          },
                          expression: "selectedStation"
                        }
                      }),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.stationError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "row clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "button-demo" }, [
                  _c("input", {
                    staticClass: "btn btn-primary",
                    attrs: {
                      id: "addBenifitBtn",
                      type: "submit",
                      value: "Save"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.addUpdateStationLocation()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "btn btn-primary",
                    attrs: {
                      id: "addAndContinueBenifitBtn",
                      type: "submit",
                      value: "Save and Continue"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.addUpdateStationLocation(
                          (_vm.flag = "Save and Continue")
                        )
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "btn btn-primary",
                    attrs: {
                      id: "CancelBenifit",
                      type: "submit",
                      value: "Cancel"
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.buttonBack.apply(null, arguments)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("app-footer")
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "selectedLocation" } }, [
      _vm._v("Select Location"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "selectedStation" } }, [
      _vm._v("Select Station"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-431238e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431238e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddUpdateStationLocation.vue
// module id = null
// module chunks = 